// shared/api-helpers.js
export function loadAutomations(productId, wishlistId, customerId, listType, nonce) {
	if (!productId || !wishlistId || !customerId) return;

	const l10n = window.wlfmc_l10n || {};
	const action = (l10n.actions && l10n.actions.load_automations) || 'wlfmc_load_automations';
	const isRest = l10n.ajax_mode === 'rest_api';

	const formData = new FormData();
	formData.append('action', action);
	formData.append('nonce', nonce || l10n.nonce || '');
	formData.append('context', 'frontend');
	formData.append('product_id', String(productId));
	formData.append('wishlist_id', String(wishlistId));
	formData.append('customer_id', String(customerId));
	formData.append('list_type', listType);

	const options = { method: 'POST', body: formData };
	const headers = {};
	if (isRest && l10n.nonce) {
		headers['X-WP-Nonce'] = l10n.nonce;
		options.headers = headers;
	}

	return fetch(l10n.ajax_url , options)
		.catch(error => console.warn('[API] Load automations failed:', error));
}
